module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [(!_vm.isEmpty(_vm.model)) ? _c('table', {
    staticClass: "table"
  }, [_c('tr', {
    staticClass: "table__row"
  }, [_c('td', {
    staticClass: "table__data"
  }, [_c('h2', {
    staticClass: "order-number__headline"
  }, [_vm._v("\n                    " + _vm._s(_vm.model.order_number) + "\n                ")])]), _vm._v(" "), _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Delivery to")]), _c('br'), _vm._v(" "), (_vm.model.company) ? _c('span', [_vm._v(_vm._s(_vm.model.company))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                    " + _vm._s(_vm.model.ship_address.firstname) + "\n                    " + _vm._s(_vm.model.ship_address.lastname))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.model.ship_address.address1))]), _c('br'), _vm._v(" "), (_vm.model.ship_address.address2) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.model.ship_address.address2) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.model.ship_address.city) + ",\n                    " + _vm._s(_vm.model.ship_address.zip) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.model.ship_address.country))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.model.email))]), _c('br')])]), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Order Date")]), _c('br'), _vm._v("\n                " + _vm._s(_vm._f("datetime")(_vm.model.ordered_on)) + "\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Payment Method")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.model.payments[0].payment_type) + " (" + _vm._s(_vm._f("datetime")(_vm.model.payments[0].created_at)) + ")\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Delivery Details")]), _c('br'), _vm._v("\n                " + _vm._s(_vm.model.shipping_method_name) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Customer Note")]), _c('br'), _vm._v(" "), _c('ul', _vm._l((_vm.model.shipping_notes), function(note, key) {
    return _c('li', {
      key: key
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatNoteObjectKey(key)) + ":")]), _vm._v("\n                        " + _vm._s(note) + "\n                    ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty(_vm.model)) ? _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.model.order_items), function(product) {
    return _c('tr', {
      key: product.id,
      staticClass: "table__row"
    }, [_c('td', {
      staticClass: "table__data"
    }, [_vm._v("\n                " + _vm._s(product.meta_data.name)), _c('br'), _vm._v("\n                SKU: " + _vm._s(product.meta_data.sku) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "table__data"
    }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(product.value, _vm.model.currency)) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "table__data"
    }, [_vm._v("\n                " + _vm._s(product.quantity) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "table__data"
    }, [(
      product.meta_data &&
      product.meta_data.properties &&
      _vm.isDynamicPricePackage(product.meta_data.properties)
    ) ? _c('div', [(product.total_value && product.discount) ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")((product.total_value -
      Math.abs(product.discount)), _vm.model.currency + ' ')) + "\n                    ")]) : _vm._e(), _vm._v(" "), (product.total_value) ? _c('div', {
      staticClass: "text-zinc-400"
    }, [_c('del', [_vm._v(_vm._s(_vm._f("currency")(product.total_value, _vm.model.currency + ' ')))])]) : _vm._e(), _vm._v(" "), (product.discount) ? _c('div', [_c('strong', [_vm._v("Your savings:")]), _c('br'), _vm._v(_vm._s(_vm._f("currency")(Math.abs(product.discount), _vm.model.currency + ' ')) + "\n                    ")]) : _vm._e()]) : (product.total_value) ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(product.total_value, _vm.model.currency + ' ')) + "\n                ")]) : _vm._e()])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.model.coupon_discount, _vm.model.currency)) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.model.subtotal, _vm.model.currency)) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.model.shipping, _vm.model.currency)) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.model.tax, _vm.model.currency)) + "\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "table__row"
  }, [_vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("currency")(_vm.model.total, _vm.model.currency)))])])])], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "table__row"
  }, [_c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Price")])]), _vm._v(" "), _c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Amount")])]), _vm._v(" "), _c('td', {
    staticClass: "table__data"
  }, [_c('strong', [_vm._v("Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Coupon discount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Subtotal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Versand")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Tax")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "table__data",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Total")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-007ec35c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueCrudPrint.vue
// module id = 516
// module chunks = 1